import React from 'react';
import {
  Grid,
  Button,
} from '@material-ui/core';

const FormSubmitButton = () => (
  <Grid item xs={12} sm={3} md={2}>
    <Button type="submit" fullWidth variant="contained" color="primary">
      Aceptar
    </Button>
  </Grid>
);

export default FormSubmitButton;



// WEBPACK FOOTER //
// ./src/components/FormSubmitButton.js